import { useEffect, useState } from 'react';

/**
 * Wall-clock ms that ticks while `enabled`, for live retry countdowns.
 * Keeps a 1s cadence so "next retry in Xm Ys" stays fresh without refetch spam.
 */
export function useTickingNow(enabled: boolean, intervalMs = 1000): number {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    if (!enabled) return;
    setNowMs(Date.now());
    const id = window.setInterval(() => setNowMs(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [enabled, intervalMs]);

  return nowMs;
}
